import { Box, Flex, Group, Pill, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { ProjectValidationAction } from '@/module/Author/Project/Validation/ProjectValidationAction';
import { ProjectValidationHistory } from '@/module/Author/Project/Validation/ProjectValidationHistory';
import { ProjectDeleteButton } from '@/module/Author/Project/components/ProjectDeleteButton';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList, PublishedAtText } from '@feature/utils';

import { ProjectProofAction } from './Proof';
import { Project } from './model/ProjectTypes';

interface ProjectViewProps {
  project: Project;
}

export function ProjectView(props: ProjectViewProps) {
  const { project } = props;
  const { t } = useTranslation();
  const {
    title,
    contractValue,
    currency,
    competitionName,
    financing,
    competitionType,
    registrationNumber,
    contractNo,
    startDate,
    endDate,
    authors,
    statusYear,
    contribution,
    competition,
  } = project;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{title}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <ProjectDeleteButton projectId={project.id} />
            </Group>
          </Flex>
          <Group gap="xs">
            <PublishedAtText
              c="dimmed"
              size="sm"
              date={startDate}
            />
            <Text c="dimmed">-</Text>
            <PublishedAtText
              c="dimmed"
              size="sm"
              date={endDate}
            />
          </Group>
          <Group gap="xs">
            <Text
              c="dimmed"
              size="sm"
            >
              {financing?.financerName}
            </Text>
            <Text
              c="dimmed"
              size="sm"
            >
              {financing?.type?.name}
            </Text>
            <Text
              c="dimmed"
              size="sm"
            >
              {contractValue} {currency}
            </Text>
          </Group>
          <Group>
            <Pill>
              {competition?.name} {competitionName ? `- ${competitionName}` : ''} {competitionType?.name}
            </Pill>
            {registrationNumber && <Pill>{registrationNumber}</Pill>}
            {contractNo && <Pill>{contractNo}</Pill>}
            {contribution && <Pill>{contribution?.name}</Pill>}
          </Group>
        </Stack>
      </Content>
      <Content type="full">
        <Stack>
          {statusYear.map(sy => (
            <Box key={sy.id}>
              <Text>
                {sy.year} - {t(`projects.statusEnum.${sy.status}`)}
              </Text>
            </Box>
          ))}
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <ProjectProofAction
        projectId={project.id}
        authors={authors}
      />
      <ProjectValidationAction projectId={project.id} />
      <ProjectValidationHistory projectId={project.id} />
    </Stack>
  );
}
